import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';
import ErrorBoundary from '../../hocs/ErrorBoundary/ErrorBoundary';
import Cart from '../Cart/Cart';
import { addEvent, removeEvent, hasClass, addClass, removeClass } from '../../utils/dom';
import s from './Header.scss';

export default class Header extends PureComponent {
	static fetchData(props) {
		const { getNavigation, getShopifyClient, getProductList } = props;

		return Promise.all([
			getNavigation().then(() => getShopifyClient()),
			getProductList(),
		]);
	}

	constructor(props) {
		super(props);
		const { addQuery } = props;

		if (typeof window !== 'undefined') {
			const query = window.location.search;
			const $html = document.querySelector('html');
			if (query !== '') {
				const queryObject = query.slice(1).split('&').reduce((acc, q) => {
					const vars = q.split('=');
					return { ...acc, [vars[0].trim()]: vars[1].trim() };
				}, {});

				if (queryObject.preview !== undefined) {
					addQuery(queryObject.preview);
				}
			}

			if ('ontouchstart' in document.documentElement) {
				removeClass($html, 'no-touchevents');
				addClass($html, 'touchevents');
			}
			if (hasClass($html, 'no-touchevents')) {
				addEvent(window, 'touchstart', () => {
					removeClass($html, 'no-touchevents');
					addClass($html, 'touchevents');
					removeEvent(window, 'touchstart');
				});
			}
		}
	}

	componentDidMount() {
		Header.fetchData(this.props);
	}

	showBagPopupHandler(e) {
		const $html = document.querySelector('html');
		if (hasClass($html, 'touchevents')) {
			e.preventDefault();
			this.props.showBagPopup();
		}
	}

	render() {
		const { shop, productList, setup, navigation, adjustItem } = this.props;
		if (setup.siteClosed || setup.siteClosed === undefined) return null;
		const staticTexts = setup !== undefined ? setup.static : false;
		const shopAvailable = !setup.siteClosed && !setup.shopClosed;
		const items = shop.checkout.items;
		const totalQuantity = Object.keys(items).length > 0 ? Object.keys(shop.checkout.items).reduce((acc, item) => acc + shop.checkout.items[item].quantity, 0) : 0;

		const headerClasses = [s.header];
		if (shop.showPopup) headerClasses.push('is_showingCart');
		if (navigation.sideMenuOpen) headerClasses.push(s.header__mobileMenuOpen);

		return (
			<header className={headerClasses.join(' ')}>
				<Link to="/shop" className={s.logo}>
					<Logo />
				</Link>
				<ErrorBoundary message={`Cart: ${productList}`}>
					{
						staticTexts && shopAvailable ? (
							<ul className={s.rightMenu}>
								<li className={`${s.rightMenu_item} ${s[`rightMenu_item__${totalQuantity}`]}`}>
									<Link className={[s.rightMenu_item_link, s.rightMenu_item_link__desktop].join(' ')} to="/bag">{ staticTexts.bag }: {totalQuantity}</Link>
									{
										totalQuantity > 0 ? <Cart popup shop={shop} productList={productList} staticTexts={staticTexts} adjustItem={adjustItem} /> : null
									}
								</li>
							</ul>
						) : null
					}
				</ErrorBoundary>
			</header>
		);
	}
}



// WEBPACK FOOTER //
// ./components/Header/Header.jsx